import {getSelectUnstyledUtilityClass} from '@mui/base';
import React, {useState} from 'react';

export const HeadEmpreas = (props) => {
	const {
		nombreEmpresa,
		setNombreEmpresa,
		emailEmpresa,
		setEmailEmpresa,
		Seleccion,
		cambioSeleccion,
	} = props;

	const [Categorias, setCategorias] = useState(false);
	const [Servicios, setServicios] = useState(false);

	return (
		<>
			<div className='headEmpresas'>
				<div className='superiorHeadContentUsuarios'>
					<div>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='40'
							height='40'
							fill='currentColor'
							className='bi bi-briefcase'
							viewBox='0 0 16 16'
						>
							<path d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z' />
						</svg>
					</div>
					<div className='centrador titleHeadHistorialFacturas'>Empresas</div>
				</div>
				<div className='separador' />
				<div className='filtrosUsuario'>
					<div className='inputFechaFacturas'>
						<input
							type='text'
							placeholder='Buscar por email de la empresa'
							value={emailEmpresa}
							onChange={(event) => setEmailEmpresa(event.target.value)}
						/>
					</div>
					<div className='inputFechaFacturas'>
						<input
							type='text'
							placeholder='Buscar por nombre de empresa'
							value={nombreEmpresa}
							onChange={(event) => setNombreEmpresa(event.target.value)}
						/>
					</div>
				</div>
				<div className='separador' />
				<div className='menuUserFeedback BotonesSuperiorPresupuestos'>
					<div
						className={Seleccion[0][0]}
						onClick={() => cambioSeleccion(0)}
					>
						<div className='centrador'>{Seleccion[0][1]}</div>
					</div>
					<div
						className={Seleccion[1][0]}
						onClick={() => cambioSeleccion(1)}
					>
						<div className='centrador'>{Seleccion[1][1]}</div>
					</div>
					<div
						className={Seleccion[2][0]}
						onClick={() => cambioSeleccion(2)}
					>
						<div className='centrador'>{Seleccion[2][1]}</div>
					</div>
				</div>
			</div>
		</>
	);
};
